import { createAction } from "redux-actions";

const storeExportBackups = createAction("STORE_EXPORT_BACKUPS");

export const indexExportBackups = createAction("API_INDEX_EXPORT_BACKUPS", (page, per_page, version) => ({
  baseURL: process.env.REACT_APP_SATTV_ENDPOINT,
  url: `/via-export${version ? "-v" + version : ""}-reports?page=${page}&per_page=${per_page}`,
  onSuccessAction: storeExportBackups
}));
